import { Page } from '@optools/components/layout/page';
import { authorizedRouteLoader } from '@optools/utils/auth/authorized-route-loader';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/ip-override')({
  beforeLoad: authorizedRouteLoader('ipOverride'),
  component: RouteComponent,
});

export function RouteComponent() {
  return (
    <Page
      links={[
        { label: 'User Lookup', to: '/ip-override/user-lookup' },
        { label: 'Overrides', to: '/ip-override/overrides' },
      ]}
      title="Blackout Override"
    />
  );
}
